export default __webpack_public_path__ + "0592cd6a2d75bb0b9f06603ef3b58288.svg";